import Swal from "sweetalert2";
import { clearBillings, clearCustomer, clearDevices, clearIndicators, clearListMemberships, clearMemberships, clearOrderDetail, clearOrders, clearSales, processRequest, setBillings, setCustomer, setCustomerClearID, setCustomerID, setDevices, setError, setIndicators, setListMemberships, setMemberships, setOrderDetail, setOrders, setSales } from "./Slice";
import apiConnection from "../../app/Connection";
import { getDateHour } from "../../utils/DateHour";

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    didOpen: (toast) => {
        // toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});

export const setCustomerDetail = (idCustomer) => {
    return (dispatch, getState) => {
        dispatch(setCustomerID({
            idCustomer: idCustomer
        }));
    }
}
export const setCustomerClearDetail = () => {
    return (dispatch, getState) => {
        dispatch(setCustomerClearID());
        dispatch(clearIndicators());
        dispatch(clearCustomer());
        dispatch(clearDevices());
        dispatch(clearBillings());
        dispatch(clearOrders());
        dispatch(clearSales());
    }
}







// ===================================== //
// === Cliente - Customer - Cliente  === //
// ===================================== //
export const loadCustomer = (idCustomer) => {
    return async (dispatch, getState) => {
        dispatch(clearCustomer());
        dispatch(processRequest());
        await apiConnection.get(`/Clientes/getCliente/${idCustomer}`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    setCustomer({
                        dataCustomer: response.data.data,
                    })
                );
            }
            else {
                dispatch(setError())
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}

export const editCustomer = (data, idCustomer) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        await apiConnection.put(`Clientes/putCliente/${idCustomer}`, {
            nombre: data.NOMBRE,
            telefono: data.TELEFONO,
            celular: data.CELULAR,
            nacimiento: data.FECHA_NAC,
            email: data.EMAIL,
            tipo_cliente: data.TIPO_CLIENTE,
            estado: 1,

        }).then(function (response) {
            if (response.data.status = 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Datos actualizados con exito'
                })
                dispatch(loadCustomer(idCustomer))
            }
            else {
                dispatch(setError())
            }
        }).catch(function (error) {
            dispatch(setError())
        });
    }
}

// =============================================== //
// === Indicadores - Indicators - Indicadores  === //
// =============================================== //
export const loadIndicators = (idCustomer) => {
    return async (dispatch, getState) => {
        dispatch(clearIndicators());
        dispatch(processRequest());
        await apiConnection.get(`/Clientes/getIndicadoresCliente/${idCustomer}`).then(function (response) {

            if (response.data.status == 200) {
                dispatch(
                    setIndicators({
                        indicators: response.data,
                    })
                );
            }
            else {
                dispatch(setError())
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}

// ============================================== //
// === Membresias - Memberships - Membresias  === //
// ============================================== //

export const loadCatMemberships = () => {
    return async (dispatch, getState) => {
        dispatch(clearListMemberships());
        dispatch(processRequest());
        await apiConnection.get(`/Clientes/getListMemberships`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    setListMemberships({
                        catMemberships: response.data.data,
                    })
                );
            }
            else {
                dispatch(setError())
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}

export const loadMemberships = (idCustomer) => {
    return async (dispatch, getState) => {
        dispatch(clearMemberships());
        dispatch(processRequest());
        await apiConnection.get(`/Clientes/getMembresias/${idCustomer}`).then(function (response) {
            console.log(response);

            if (response.data.status == 200) {
                dispatch(
                    setMemberships({
                        memberships: response.data.data,
                    })
                );
            }
            else {
                dispatch(setError())
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}

export const closeSales = (payload) => {

    let dat = new Date(); let d = dat.getDate(); let m = dat.getMonth() + 1; if (d < 10) d = "0" + d; if (m < 10) m = "0" + m;
    let fechahora = new Date(); let hora = fechahora.getHours(); let minuto = fechahora.getMinutes(); let segundo = fechahora.getSeconds();
    if (minuto < 10) minuto = "0" + minuto; if (segundo < 10) segundo = "0" + segundo;
    let fechaRegistro = dat.getFullYear() + "-" + m + "-" + d;
    let horaRegistro = `${hora}:${minuto}:${segundo}`;
    // console.log(payload);

    return async (dispatch, getState) => {
        dispatch(processRequest());

        // Necesito lanzar otra peticion para guardar los datos de la membresia, asociarla al cliente
        // Luego realizar el cobro

        await apiConnection.post(`Incomes/postMembership`, {
            idCustomer: payload.idCliente,
            userRegister: payload.capturo,
            dateRegister: fechaRegistro,
            hourRegister: horaRegistro,
            incomeTypeRegister: 2,
            change: payload.cambio,
            iva: payload.iva,
            subtotal: payload.total,
            amountRegister: payload.total,
            detailIncome: payload.detailPagos,
            idFacturacion: payload.idFacturacion,
            flagFacturacion: payload.flagFacturacion,
            flagSpecial: payload.flagSpecial,
            productsDetail: payload.productos,
            costoHDL: payload.costohdl,
            tecnicoAsignado: payload.tecnico,
            idcapturo: payload.idcapturo
        }).then(function (response) {
            if (response.data.status == 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Exito',
                    text: `${response.data.msg}`,
                    confirmButtonText: 'Aceptar',
                    customClass: { confirmButton: 'btn btn-primary' }, buttonsStyling: false,
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.isConfirmed) {
                        dispatch(loadMemberships(payload.idCliente)); // <-- cambiar a loading por cliente

                        if (payload.flagSpecial == 0) {
                            window.open(`./assets/reports/ordenVenta.html?folio=${response.data.folio}&opcion=0`, '_blank');
                        }

                        if (payload.flagSpecial == 1) {
                            window.open(`./assets/reports/ordenVenta.html?folio=${response.data.folio}&opcion=0`, '_blank');
                        }

                        if (payload.flagSpecial == 2) {
                            window.open(`./assets/reports/compAnticipo.html?folio=${response.data.folio}&opcion=1`, '_blank');
                        }
                        if (payload.flagSpecial == 3) {
                            // window.open(`./assets/reports/compAnticipo.html?folio=${response.data.folio}&opcion=1`, '_blank');
                            window.open(`./assets/reports/ordenVenta.html?folio=${response.data.folio}&opcion=1`, '_blank');
                        }

                        // window.location.reload();
                    }
                });
            }
        }).catch(function (error) {
            console.log(error);
        });
    }

}

export const activateMemberships = (id, idCustomer) => {
    return async (dispatch, getState) => {
        dispatch(clearMemberships());
        dispatch(processRequest());
        await apiConnection.put(`Clientes/putMembresiaAct/${id}`).then(function (response) {
            if (response.data.status == 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Membresia activada'
                })
                dispatch(loadMemberships(idCustomer));
            }
            else {
                dispatch(loadMemberships(idCustomer));
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(loadMemberships(idCustomer));
        });
    }
}

export const deactivateMemberships = (id, idCustomer) => {
    return async (dispatch, getState) => {
        dispatch(clearMemberships());
        dispatch(processRequest());
        await apiConnection.put(`Clientes/putMembresiaDel/${id}`).then(function (response) {
            if (response.data.status == 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Membresia desactivada'
                });
                dispatch(loadMemberships(idCustomer));
            }
            else {
                dispatch(loadMemberships(idCustomer));
            }
        }).catch(function (error) {
            dispatch(setError());
            dispatch(loadMemberships(idCustomer));
        });
    }
}



// ============================================= //
// === Facturacion - Billings - Facturacion  === //
// ============================================= //

export const loadBillings = (idCustomer) => {
    return async (dispatch, getState) => {
        dispatch(clearBillings());
        dispatch(processRequest());
        await apiConnection.get(`Facturacion/getFacturacion/${idCustomer}`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(setBillings({ billings: response.data.data }))
            }
            else {
                dispatch(setError());
            }
        }).catch(function (error) {
            dispatch(setError());
        });
    }
}

export const newBilling = (data, user, idCustomer, tempKey) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        let dat = new Date();
        let d = dat.getDate();
        let m = dat.getMonth() + 1;
        if (d < 10) d = "0" + d; if (m < 10) m = "0" + m;
        let fechahora = new Date();
        let hora = fechahora.getHours();
        let minuto = fechahora.getMinutes();
        let segundo = fechahora.getSeconds();
        if (minuto < 10) minuto = "0" + minuto; if (segundo < 10) segundo = "0" + segundo;

        let fechaRegistro = dat.getFullYear() + "/" + m + "/" + d; let horaRegistro = `${hora}:${minuto}:${segundo}`;

        await apiConnection.post(`Facturacion/postFacturacion`, {
            rfc: data.rfc,
            r_social: data.razonSocial,
            so_mercantil: data.sociedad,
            regimen: data.regimen,
            telefono: data.numberPhone,
            email: data.email,
            direccion: data.direccion,
            cp: data.cp,
            cliente_id: idCustomer,
            usuario: user,
            fecha: fechaRegistro,
            hora: horaRegistro,
            estado: 1,
            tempkey: tempKey
        }).then(function (response) {

            if (response.data.status == 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Facturacion registrada con exito'
                })
                dispatch(loadBillings(idCustomer));
            }

        }).catch(function (error) {
            console.log(error)
            Toast.fire({
                icon: 'error',
                title: 'No se registro la Facturacion... Intente de Nuevo'
            })
            dispatch(loadBillings(idCustomer));
            return;
        });
    }
}

export const updateBillingWithFile = (data, idRegister, user, idCustomer, tempKey) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        let dat = new Date();
        let d = dat.getDate();
        let m = dat.getMonth() + 1;
        if (d < 10) d = "0" + d; if (m < 10) m = "0" + m;
        let fechahora = new Date();
        let hora = fechahora.getHours();
        let minuto = fechahora.getMinutes();
        let segundo = fechahora.getSeconds();
        if (minuto < 10) minuto = "0" + minuto; if (segundo < 10) segundo = "0" + segundo;

        let fechaRegistro = dat.getFullYear() + "/" + m + "/" + d; let horaRegistro = `${hora}:${minuto}:${segundo}`;

        await apiConnection.post(`Facturacion/postFacturacionWithFile`, {
            rfc: data.rfc,
            r_social: data.razonSocial,
            so_mercantil: data.sociedad,
            regimen: data.regimen,
            telefono: data.numberPhone,
            email: data.email,
            direccion: data.direccion,
            cp: data.cp,
            cliente_id: idCustomer,
            usuario: user,
            fecha: fechaRegistro,
            hora: horaRegistro,
            estado: 1,
            tempkey: tempKey,
            idregister: idRegister
        }).then(function (response) {

            if (response.data.status == 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Facturacion registrada con exito'
                })
                dispatch(loadBillings(idCustomer));
            }

        }).catch(function (error) {
            console.log(error)
            Toast.fire({
                icon: 'error',
                title: 'No se registro la Facturacion... Intente de Nuevo'
            })
            dispatch(loadBillings(idCustomer));
            return;
        });
    }
}

export const updateBillingWithoutFile = (data, idRegister, user, idCustomer) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        let dat = new Date();
        let d = dat.getDate();
        let m = dat.getMonth() + 1;
        if (d < 10) d = "0" + d; if (m < 10) m = "0" + m;
        let fechahora = new Date();
        let hora = fechahora.getHours();
        let minuto = fechahora.getMinutes();
        let segundo = fechahora.getSeconds();
        if (minuto < 10) minuto = "0" + minuto; if (segundo < 10) segundo = "0" + segundo;

        let fechaRegistro = dat.getFullYear() + "/" + m + "/" + d; let horaRegistro = `${hora}:${minuto}:${segundo}`;

        await apiConnection.post(`Facturacion/postFacturacionNotFile`, {
            rfc: data.rfc,
            r_social: data.razonSocial,
            so_mercantil: data.sociedad,
            regimen: data.regimen,
            telefono: data.numberPhone,
            email: data.email,
            direccion: data.direccion,
            cp: data.cp,
            cliente_id: idCustomer,
            usuario: user,
            fecha: fechaRegistro,
            hora: horaRegistro,
            estado: 1,
            idregister: idRegister
        }).then(function (response) {

            if (response.data.status == 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Facturacion registrada con exito'
                })
                dispatch(loadBillings(idCustomer));
            }

        }).catch(function (error) {
            console.log(error)
            Toast.fire({
                icon: 'error',
                title: 'No se registro la Facturacion... Intente de Nuevo'
            })
            dispatch(loadBillings(idCustomer));
            return;
        });
    }
}

export const activateBillings = (id, idCustomer) => {
    return async (dispatch, getState) => {
        dispatch(clearBillings());
        dispatch(processRequest());
        await apiConnection.put(`Facturacion/putFacturacionAct/${id}`).then(function (response) {
            if (response.data.status == 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Facturacion activada'
                })
                dispatch(loadBillings(idCustomer));
            }
            else {
                dispatch(loadBillings(idCustomer));
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(loadBillings(idCustomer));
        });
    }
}

export const deactivateBillings = (id, idCustomer) => {
    return async (dispatch, getState) => {
        dispatch(clearBillings());
        dispatch(processRequest());
        await apiConnection.put(`Facturacion/putFacturacionDel/${id}`).then(function (response) {
            if (response.data.status == 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Facturacion desactivada'
                });
                dispatch(loadBillings(idCustomer));
            }
            else {
                dispatch(loadBillings(idCustomer));
            }
        }).catch(function (error) {
            dispatch(setError());
            dispatch(loadBillings(idCustomer));
        });
    }
}

// ==================================== //
// ===   Ventas - Sales - Ventas    === //
// ==================================== //
export const loadSales = (idCustomer) => {
    return async (dispatch, getState) => {
        dispatch(clearSales());
        dispatch(processRequest());
        await apiConnection.get(`Ventas/getVentasCliente/${idCustomer}`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    dispatch(setSales({ sales: response.data.data }))
                );
            }
            else {
                dispatch(setError())
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}

// ==================================== //
// ===  Ordenes - Orders - Ordenes  === //
// ==================================== //
export const loadOrders = (idCustomer) => {
    return async (dispatch, getState) => {
        dispatch(clearOrders());
        dispatch(processRequest());
        await apiConnection.get(`OrdenesServicio/getOrdenesCliente/${idCustomer}`).then(function (response) {
            if (response.data.status == 200) {

                dispatch(
                    dispatch(setOrders({ orders: response.data.data }))
                );
            }
            else {
                dispatch(setError())
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}

export const loadOrderDetail = (idOrder) => {
    return async (dispatch, getState) => {
        dispatch(clearOrderDetail());
        dispatch(processRequest());
        await apiConnection.get(`OrdenesServicio/getOrdenServicioDetail/${idOrder}`).then(function (response) {
            if (response.data.status == 200) {

                dispatch(
                    dispatch(setOrderDetail({ order: response.data.data }))
                );
            }
            else {
                dispatch(setError())
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}

export const loadOrdersByDevice = (idCustomer, equipo) => {
    return async (dispatch, getState) => {
        dispatch(clearOrders());
        dispatch(processRequest());
        await apiConnection.get(`OrdenesServicio/getOrdenesClienteByDevices/${idCustomer}/${equipo}`).then(function (response) {
            if (response.data.status == 200) {

                dispatch(
                    dispatch(setOrders({ orders: response.data.data }))
                );
            }
            else {
                dispatch(setError())
            }
        }).catch(function (error) {
            // console.log(error);
            dispatch(setError())
        });
    }
}

// ==================================== //
// === Equipos - Devices - Equipos  === //
// ==================================== //
export const loadDevices = (idCustomer) => {
    return async (dispatch, getState) => {
        dispatch(clearDevices());
        dispatch(processRequest());
        await apiConnection.get(`/Equipos/getEquipos/${idCustomer}`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    setDevices({
                        devices: response.data.data,
                    })
                );
            }
            else {
                dispatch(setError())
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}

export const newDevice = (data, idUser, idCustomer) => {
    return async (dispatch, getState) => {

        let dat = new Date();
        let d = dat.getDate();
        let m = dat.getMonth() + 1;
        if (d < 10) d = "0" + d; if (m < 10) m = "0" + m;
        let fechahora = new Date();
        let hora = fechahora.getHours();
        let minuto = fechahora.getMinutes();
        let segundo = fechahora.getSeconds();
        if (minuto < 10) minuto = "0" + minuto; if (segundo < 10) segundo = "0" + segundo;

        let fechaRegistro = dat.getFullYear() + "/" + m + "/" + d; let horaRegistro = `${hora}:${minuto}:${segundo}`;

        await apiConnection.post(`Equipos/postEquipo`, {
            tipo_id: data.categoryID,
            marca_id: data.brandID,
            modelo: data.modelDevice,
            no_serie: data.noSerie,
            s_operativo: data.systemOperative,
            cliente_id: idCustomer,
            usuario: idUser,
            fecha: fechaRegistro,
            hora: horaRegistro,
            estado: 1,

        }).then(function (response) {
            if (response.data.status = 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Equipo registrado con exito'
                })
                dispatch(loadDevices(idCustomer));
            }
        }).catch(function (error) {
            console.log(error)
            Toast.fire({
                icon: 'error',
                title: 'No se registro el Equipo... Intente de Nuevo'
            })
            dispatch(loadDevices(idCustomer));
            return;
        });

    }

}

export const deactivateDevice = (id, idCustomer) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        await apiConnection.put(`Equipos/putEquipoDel/${id}`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(clearDevices());
                dispatch(loadDevices(idCustomer));
                Toast.fire({
                    icon: 'success',
                    title: 'Equipo Desactivado con exito'
                })
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}

export const activateDevice = (id, idCustomer) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        await apiConnection.put(`Equipos/putEquipoAct/${id}`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(clearDevices());
                dispatch(loadDevices(idCustomer));
                Toast.fire({
                    icon: 'success',
                    title: 'Equipo Activado con exito'
                })
            }
        }).catch(function (error) {
            console.log(error);
        });
    }
}


//Funcion para subir fotografias

export const uploadEvidence = (tempkey, userupload, fileItem, meta) => async (dispatch) => {
    console.log(tempkey);
    console.log(userupload);
    console.log(fileItem);
    console.log(meta);

    const { fecha, hora, fuente } = await getDateHour();
    const formData = new FormData();

    // console.log(meta);
    formData.append('tempkey', tempkey);
    formData.append('file', fileItem.file);
    formData.append('module', meta.module);
    formData.append('entity_type', meta.entity_type);
    formData.append('entity_id', meta.entity_id);
    formData.append('userupload', userupload);
    formData.append('dateupload', fecha);
    formData.append('hourupload', hora);

    try {
        const res = await apiConnection.post('/Facturacion/uploadCSF', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        // dispatch(loadEvidences(reference))
        return { ok: true, data: res.data };

    } catch (err) {
        return { ok: false, error: err.message };
    }
};